import AuthState, { AuthStatus } from '@/store/modules/auth/authState';

const state: Partial<AuthState> = {
  status: AuthStatus.Unknown,
  awaitingB2CResponse: false,
};

export default state;
